import { gql } from '@apollo/client'

/** 消息片段 */
export const CHAT_MESSAGE_FIELDS = gql`
  fragment chatMessageFields on ChatMessage {
    id
    createTime
    parentId
    role
    searchEnabled
    thinkingContent {
      id
      content
    }
    thinkingEnabled
    content {
      id
      content
      image
      referImages
    }
    thinkingTime
    conversationId
    searchContents {
      content
      contentType
      favicon
      id
      site
      snippet
      title
      url
      date
    }
    status
    model
  }
`
/** 会话列表 */
export const GET_CONVERSATION_LIST = gql`
  ${CHAT_MESSAGE_FIELDS}
  query getConversationList(
    $first: Int
    $offset: Int
    $param: ConversationQueryParam
  ) {
    openAiQuery {
      pageConversation(
        page: { first: $first, offset: $offset }
        param: $param
      ) {
        edges {
          node {
            id
            title
            createTime
            updateTime
            currentMessage {
              ...chatMessageFields
            }
          }
        }
      }
    }
  }
`

/** 会话详情 */
export const GET_CHAT_MESSAGE = gql`
  ${CHAT_MESSAGE_FIELDS}
  query getChatMessage($id: Long!) {
    openAiQuery {
      chatMessage(conversationId: $id) {
        ...chatMessageFields
      }
    }
  }
`

/** 删除会话 */
export const DELETE_CONVERSATION = gql`
  mutation deleteConversation($id: Long!) {
    openAiMutation {
      status: deleteConversation(id: $id)
    }
  }
`

/** 初始化🎨 */
export const INIT_CONVERSATION = gql`
  mutation conversationInitiate($input: ConversationInitiateInput) {
    openAiMutation {
      conversationInitiate(input: $input) {
        id
      }
    }
  }
`
/** 更新会话信息 */
export const UPDATE_CONVERSATION = gql`
  mutation updateConversation($input: ConversationUpdateInput!) {
    openAiMutation {
      updateConversation(input: $input) {
        id
      }
    }
  }
`

/** 发送消息 */
export const SEND_MESSAGE = gql`
  ${CHAT_MESSAGE_FIELDS}
  mutation sendMessage($input: ConversationRequest) {
    openAiMutation {
      conversation(input: $input) {
        ...chatMessageFields
      }
    }
  }
`

/** 会话详情 */
export const POLL_CHAT_MESSAGE = gql`
  ${CHAT_MESSAGE_FIELDS}
  query pollChatMessage($messageIdList: [Long]) {
    openAiQuery {
      chatMessagesPolling(messageIdList: $messageIdList) {
        ...chatMessageFields
      }
    }
  }
`

/** 终止会话 */
export const TERMINATE_MESSAGE = gql`
  mutation terminateMessage($messageId: Long!) {
    openAiMutation {
      terminateGeneration(messageId: $messageId)
    }
  }
`
